import React from 'react'

import { motion } from 'framer-motion/dist/framer-motion'

import style from './Button.module.scss'

export const Button = React.forwardRef(
	({ children, disabled, ...props }, ref) => {
		return (
			<motion.button
				ref={ref}
				initial="initial"
				whileHover="hover"
				whileTap="tap"
				disabled={disabled}
				animate={disabled ? 'disabled' : ''}
				variants={{
					hover: {
						scale: 1.02,
					},
					tap: {
						scale: 0.98,
					},
					disabled: {
						scale: 1,
					},
				}}
				className={style.button}
				{...props}
			>
				<motion.span
					variants={{
						initial: { clipPath: 'circle(0% at 0% 50%)' },
						hover: {
							clipPath: 'circle(170% at 0% 50%)',
							transition: {
								duration: 1,
								type: 'spring',
							},
						},
						disabled: {
							clipPath: [
								'circle(170% at 0% 50%)',
								'circle(0% at 0% 50%)',
							],
							transition: {
								duration: 1.4,
								repeat: Infinity,
								repeatType: 'reverse',
							},
						},
					}}
					className={style.button__mask}
				></motion.span>
				<motion.span className={style.button__text}>
					{children}
				</motion.span>
			</motion.button>
		)
	}
)
